import React, { useState } from "react";

import EditIcon from "@uui/Edit02";
import { toLower } from "lodash/fp";

import {
  DetailSubHeading,
  EmptyDetailText,
  SelectableChipsContainer,
} from "@app/analytics/components/reports/styles";
import useResponsiveView from "@app/common/hooks/useResponsiveView";

import { Row } from "@rui/Stack";

import {
  EditButton,
  TranscriptMetadataAccordion,
  TranscriptMetadataAccordionDetails,
  TranscriptMetadataAccordionSummary,
} from "./styles";

interface TranscriptMetadataProps {
  children: React.ReactNode;
  isEmpty: boolean;
  emptyMessage: string;
  shouldUpsell: boolean;
  title: string;
  onClickEdit?: () => void;
}

const WithEmptyFallback = ({
  children,
  emptyMessage,
  isEmpty,
}: {
  children: React.ReactNode;
  emptyMessage: string;
  isEmpty: boolean;
}) => {
  if (isEmpty) {
    return <EmptyDetailText>{emptyMessage}</EmptyDetailText>;
  }

  return <SelectableChipsContainer>{children}</SelectableChipsContainer>;
};

const TranscriptMetadata = ({
  children,
  isEmpty,
  emptyMessage,
  onClickEdit,
  shouldUpsell,
  title,
}: TranscriptMetadataProps) => {
  const { inMobileView } = useResponsiveView();
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => setExpanded((e) => !e);
  const handleClickEdit = (event: React.MouseEvent) => {
    event.stopPropagation();
    onClickEdit?.();
  };

  return (
    <TranscriptMetadataAccordion expanded={expanded || !inMobileView}>
      <TranscriptMetadataAccordionSummary onClick={toggleExpanded}>
        <Row variant="left" spacing={0.5}>
          <DetailSubHeading>{title}</DetailSubHeading>
          {onClickEdit && (
            <EditButton onClick={handleClickEdit}>
              <EditIcon />
            </EditButton>
          )}
        </Row>
      </TranscriptMetadataAccordionSummary>
      <TranscriptMetadataAccordionDetails>
        <WithEmptyFallback
          emptyMessage={
            shouldUpsell ? `Upgrade to view ${toLower(title)}` : emptyMessage
          }
          isEmpty={isEmpty || shouldUpsell}
        >
          {children}
        </WithEmptyFallback>
      </TranscriptMetadataAccordionDetails>
    </TranscriptMetadataAccordion>
  );
};

export default TranscriptMetadata;
